import React from 'react';
import ModalLayout from '../ModalLayout';
import { useTranslation } from 'react-i18next';
import { buttonStyles, redButtonStyles } from '../../styles/commonStyles';

const DeleteGroupModal = ({ isOpen, onClose, onDelete, groupName }) => {
    const { t } = useTranslation();

    return (
        <ModalLayout isOpen={isOpen} onClose={onClose}>
            <div className="mb-4">
                <h2 className="text-xl font-semibold mb-2">
                    {t("categories.deleteGroup.title", "Подтвердите удаление")}
                </h2>
            </div>
            <div className="mb-4 space-y-2">
                <p className="text-center">
                    {t("categories.deleteGroup.confirmMessage", "Вы действительно хотите удалить группу \"{{name}}\"?", { name: groupName })}
                </p>
                <p className="text-center text-gray-600 dark:text-gray-400 text-sm">
                    {t("categories.deleteGroup.warning", "При удалении группы все категории останутся с пометкой \"Без группы\"")}
                </p>
            </div>
            <div className="flex justify-end space-x-2">
                <button onClick={onClose} className={buttonStyles}>
                    {t("common.cancel", "Отмена")}
                </button>
                <button onClick={onDelete} className={redButtonStyles}>
                    {t("categories.deleteGroup.confirm", "Удалить группу")}
                </button>
            </div>
        </ModalLayout>
    );
};

export default DeleteGroupModal; 